import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
    name: 'stripTags',
    standalone: true,
    pure: true
})
export class StripTagsPipe implements PipeTransform {

    transform(html: string): string {
        let tmpDivElement = document.createElement("div")
        tmpDivElement.innerHTML = html
        return  (tmpDivElement.textContent || tmpDivElement.innerText || "").trim()
    }
}